<template>
    <div class="list-container">
        <div class="list-container-item" v-for="(item, index) in data" :key="index">
            <p>{{item}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: []
        }
    }
}
</script>